const CryptoJS = require("crypto-js");

var PostLoginPostApi = async (API_END_POINT = "", REQUEST_BODY = "", IS_PREFIX_NEED = 1, NO_NEED_DEFAULT_CT = 0, IS_PATCH = 0, NEED_VOUCHER_CODE = 0) => {
    let arr = { status: 0 };

    try {

        let api_url = process.env.REACT_APP_API_BASE_URL;

        let CompanyId = JSON.parse(localStorage.getItem('CompanyId'));
        if (IS_PREFIX_NEED === 1 && CompanyId > 0) {
            api_url += process.env.REACT_APP_API_PREFIX_COMPANY + CompanyId + "/";
        }

        if (IS_PREFIX_NEED === 2) {
            api_url = api_url + process.env.REACT_APP_API_PREFIX_FOR_VOUCHER;
        }

        if (IS_PREFIX_NEED === 3) {
            api_url = api_url + process.env.REACT_APP_API_PREFIX_ADMIN;
        }

        if (IS_PREFIX_NEED === 4) {
            api_url = api_url + process.env.REACT_APP_API_PREFIX;
        }


        var decryptData = JSON.parse(CryptoJS.AES.decrypt(window.localStorage.getItem("UserToken"), process.env.REACT_APP_SECURITY_SALT).toString(CryptoJS.enc.Utf8));


        let headerArr = {
            'Authorization': 'Bearer ' + decryptData.token,
            'Accept': 'application/json',
            'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE'
        };

        if (NEED_VOUCHER_CODE === 1) {
            headerArr["x-auth-code"] = process.env.REACT_APP_VOUCHER_AUTH_CODE;
        }

        if (NO_NEED_DEFAULT_CT === 0) {
            headerArr["Content-Type"] = "application/json";
        }

        if (NO_NEED_DEFAULT_CT === 2) {
            headerArr["Content-Type"] = "multipart/form-data";
        }

        if (NO_NEED_DEFAULT_CT === 3) {
            headerArr["Content-Type"] = "application/x-www-form-urlencoded";
        }
        

        let method = "POST";
        if (IS_PATCH === 1) {
            method = "PATCH";
        }
        else if (IS_PATCH === 2) {
            method = "PUT";
        }
        else if (IS_PATCH === 3) {
            method = "DELETE";
        }


        await fetch(api_url + API_END_POINT, {
            method: method,
            headers: new Headers(headerArr),
            body: REQUEST_BODY
        })
        .then(res => res.json())
        .then((result) => {
                arr['status'] = 1;
                arr['data'] = result;
            }, (error) => {
                arr['data'] = error;
            }
        ).catch((err) => {
            console.log(err);
        });

    }
    catch (err) {
        console.log(err.toString());
        arr['data'] = err.toString();
    }
    finally {
        if( arr["data"]["code"] === 401 ) {
            document.location.href = "/dashboard/logout";
            return;
        }
        return arr;
    }
}

export default PostLoginPostApi;

